import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {MANAGE_ROLE_PERMISSION, MANAGE_ROLE_PERMISSION_API_URL, GET_ALL_MANAGE_ROLE_PERMISSION_API_URL,
  GET_MODULE_WITH_PERMISSION,
  GET_EXCLUDED_ROLE
} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  ManageRolePermissionErrors       : {},
  permission: permission?.manage_role_permission ?? [],
  ManageRolePermissionShowMessage  : null,
  ManageRolePermissionResult       : [],
  ManageRolePermissionButtonSpinner : false,
  ManageRolePermissionTableLoading : true,
  ManageRolePermissionAddDrawer    : false,
  ManageRolePermissionEditData     : [],
  ManageRolePermissionButtonAndModelLabel  : setLocale('managerolepermission.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewManageRolePermissionData: [],
    ViewManageRolePermissionLoader: true,
    DrawerStatus: 0,
    getModuleWithPermissionResult: [],
    getModuleWithPermissionResultLoading: false,
    getExcludedRolesResult: [],
    getExcludedRolesResultLoading: false,
};

export const createManageRolePermission = createAsyncThunk(
    "createManageRolePermission",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, MANAGE_ROLE_PERMISSION_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getManageRolePermission = createAsyncThunk(
    "getManageRolePermission",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_MANAGE_ROLE_PERMISSION_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewManageRolePermission = createAsyncThunk(
  "viewManageRolePermission",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, MANAGE_ROLE_PERMISSION_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteManageRolePermission = createAsyncThunk(
  "deleteManageRolePermission",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, MANAGE_ROLE_PERMISSION_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getModuleWithPermission = createAsyncThunk(
  "getModuleWithPermission",
  async () => {
    try {
      const response = await CommonService.getAll(GET_MODULE_WITH_PERMISSION);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getExcludedRoles = createAsyncThunk(
  "getExcludedRoles",
  async () => {
    try {
      const response = await CommonService.getAll(GET_EXCLUDED_ROLE);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const manageManageRolePermissionSlice = createSlice({
  name: MANAGE_ROLE_PERMISSION,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.ManageRolePermissionErrors = {};
    },
    ManageRolePermissionAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.ManageRolePermissionButtonSpinner = false;
      }
      state.ManageRolePermissionAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManageRolePermissionEditData    = [];
      state.ManageRolePermissionButtonAndModelLabel = setLocale('managerolepermission.add');
    },
    ManageRolePermissionEditWithDrawerStatus: (state, action) => {
      state.ManageRolePermissionAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.ManageRolePermissionEditData = action.payload.data;
      state.ManageRolePermissionButtonAndModelLabel = setLocale('managerolepermission.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createManageRolePermission.pending, (state, action) => {
        state.DrawerStatus = 0
        state.ManageRolePermissionButtonSpinner = true;
      }).addCase(createManageRolePermission.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.ManageRolePermissionButtonSpinner = false;
        state.ManageRolePermissionErrors = {}
      }).addCase(createManageRolePermission.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.ManageRolePermissionShowMessage = true;
        state.ManageRolePermissionButtonSpinner = false;
        state.ManageRolePermissionErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getManageRolePermission.pending, (state, action) => {
        state.ManageRolePermissionButtonSpinner = true;
        state.ManageRolePermissionTableLoading = true;
      }).addCase(getManageRolePermission.fulfilled, (state, action) => {
        state.ManageRolePermissionButtonSpinner = false;
        state.ManageRolePermissionTableLoading = false;
        state.ManageRolePermissionResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getManageRolePermission.rejected, (state, action) => {
        state.ManageRolePermissionShowMessage = true; // Set the showMessage flag to display the errors
        state.ManageRolePermissionButtonSpinner = false;
        state.ManageRolePermissionTableLoading = false;
        state.ManageRolePermissionErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewManageRolePermission.pending, (state, action) => {
        state.ViewManageRolePermissionLoader = true;
        state.ViewManageRolePermissionData = [];
      }).addCase(viewManageRolePermission.fulfilled, (state, action) => {
        state.ViewManageRolePermissionLoader = false;
        state.ViewManageRolePermissionData = action.payload;
      }).addCase(viewManageRolePermission.rejected, (state, action) => {
        state.ViewManageRolePermissionLoader = false;
        state.ViewManageRolePermissionData = [];
      })
      .addCase(deleteManageRolePermission.pending, (state, action) => {
        state.ManageRolePermissionTableLoading = true;
      }).addCase(deleteManageRolePermission.fulfilled, (state, action) => {
        state.ManageRolePermissionTableLoading = false;
      }).addCase(deleteManageRolePermission.rejected, (state, action) => {
        state.ManageRolePermissionTableLoading = false;
      })
      .addCase(getModuleWithPermission.pending, (state, action) => {
        state.getModuleWithPermissionResultLoading = true;
      })
      .addCase(getModuleWithPermission.fulfilled, (state, action) => {
        state.getModuleWithPermissionResult = action.payload;
        state.getModuleWithPermissionResultLoading = false;
      })
      .addCase(getModuleWithPermission.rejected, (state, action) => {
        state.ManageRolePermissionErrors = JSON.parse(action.error.message);
        state.ManageRolePermissionShowMessage = true;
        state.getModuleWithPermissionResultLoading = true;
      })
      .addCase(getExcludedRoles.pending, (state, action) => {
        state.getExcludedRolesResultLoading = true;
      })
      .addCase(getExcludedRoles.fulfilled, (state, action) => {
        state.getExcludedRolesResult = action.payload;
        state.getExcludedRolesResultLoading = false;
      })
      .addCase(getExcludedRoles.rejected, (state, action) => {
        state.ManageRolePermissionErrors = JSON.parse(action.error.message);
        state.ManageRolePermissionShowMessage = true;
        state.getExcludedRolesResultLoading = true;
      });
  },
});

export const { onCloseError, setColumnSearch, ManageRolePermissionAddDrawerStatus, ManageRolePermissionEditWithDrawerStatus, updateSortFilters } = manageManageRolePermissionSlice.actions;

export default manageManageRolePermissionSlice.reducer;